import {
  GET_ACCOUNT_SETTING_DATA,
  SET_ACCOUNT_SETTING_DATA,
} from "./AccountSettingDataTypes";

const getAccountSettingData = () => {
  return {
    type: GET_ACCOUNT_SETTING_DATA,
  };
};
const setAccountSettingData = (data) => {
  return {
    type: SET_ACCOUNT_SETTING_DATA,
    payload: data,
  };
};
const AccountSettingDataAction = {
  getAccountSettingData,
  setAccountSettingData,
};
export default AccountSettingDataAction;
